import FunlidayCookie from '../utilities/funlidayCookie';
import { poiBankRequest } from './main';

const getAuthHeader = () => {
  const poiBankToken =
    FunlidayCookie.get('poibankToken').token ||
    JSON.parse(localStorage.getItem('poiBankToken')); // redundant OR
  return {
    headers: { Authorization: `Bearer ${poiBankToken}` }
  };
};

/** @method 取得景點資訊
 * @param {string | number} poiID (Required)欲查詢的目標 poi 景點 ID，以此去索取該 poi 景點資料
 * @description 欲查詢的語系不再是在 url 後面接 '?hl=${language}'，而是以 headers 內 x-funliday-language 為依據
 * @returns {Promise} axiosPromise
 */
export const getPoiDetail = poiID => {
  const config = getAuthHeader();
  return poiBankRequest.get(`poi/show/${poiID}`, config);
};

/** @method 取得景點資訊
 * @param {string | number} poiID (Required)欲查詢的目標 poi 景點 ID，以此去索取該 poi 景點資料
 * @description 取得景點所有相關商品 (包含原有的商品及導購商品)
 * @returns {Promise} axiosPromise
 * @see #2714 on redmine
 */
export const getPoiDetailProducts = poiID => {
  const config = getAuthHeader();
  return poiBankRequest.get(`poi/show/${poiID}/products`, config);
};

/**
 *
 * @param {string} keyword - 搜尋關鍵字
 * @param {string | number} type - 搜尋 1: all, 2: city, 3: place, 4: hotel, 5: search
 * @returns
 */
export const getAutoCompleteV2 = (keyword, type) => {
  const config = getAuthHeader();
  return poiBankRequest.get(
    `v2/autocomplete?type=${type}&q=${keyword}`,
    config
  );
};
